import {useEffect, useRef} from 'react';
import {useExperiments} from '@wix/yoshi-flow-editor';
import {StepId, StepState} from '../../../types/checkoutApp.types';
import {SPECS} from '../../../common/constants';
import {useControllerProps} from '../Widget/ControllerContext';

type UseReportStageExpandedProps = {
  stepState: StepState;
  stepId: StepId;
};

export const useReportStageExpanded = ({stepState, stepId}: UseReportStageExpandedProps) => {
  const {
    stepsManagerStore: {sendStageExpandedBIEvent},
    checkoutStore: {cart, cartSummary},
  } = useControllerProps();
  const {experiments} = useExperiments();
  const fixCheckoutPageSpecificStageExpanded = experiments.enabled(SPECS.FixCheckoutPageSpecificStageExpanded);
  const prevStateRef = useRef<StepState | undefined>(undefined);

  useEffect(
    () => {
      if (!fixCheckoutPageSpecificStageExpanded) {
        return;
      }
      if (stepState === StepState.OPEN && prevStateRef.current !== StepState.OPEN) {
        sendStageExpandedBIEvent({cart, cartSummary, stepId});
      }
      prevStateRef.current = stepState;
    },
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
    [stepId, stepState, fixCheckoutPageSpecificStageExpanded, cart.id]
  );
};
